// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.assessment.AddAutoDiagnosisToEncounterRequest */
/* istanbul ignore next */
@GandalfModel
export class AddAutoDiagnosisToEncounterRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Auto Diagnosis is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	autoDiagnosisId!: number;

	@GandalfValidator({ notNull: { message: 'Encounter is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	encounterId!: number;

}
